import {ComponentTypes} from "@white-label/components/page-builder/models/model.map";


export class SectionModel {
    type: ComponentTypes = ComponentTypes.text;
    backgroundColor?: any = {value: 'transparent'};
    title: any = '';
    subtitle: any = '';
    sortOrder?: any = 0;
    px?: any = 0;
    py?: any = 0;
    mx?: any = 0;
    my?: any = 0;


    enableTitle?: any = true;

    enableContainer?: any = false;
    enableBackgroundImage?: any = true;
    enableSectionSpacing?: any = true;
    showAdvancedSettings?: any = false;
    backgroundImagePosition?: any = 'bg-center';
    backgroundImageFit?: any = 'bg-center';
    enableBackgroundMask:any = false;
    enableSectionSmooth:any = false;

    backgroundImageUrl?: any = '';
    backgroundVideoUrl?: any = '';
    component: any;
    data: any;

    mobileOrder?: number | null = null;

    providerChanel: any = null;
    constructor(section?: {type?: any,
                backgroundColor?: any,
                title?: any,
                subtitle?: any,
                sortOrder?: any,
                px?: any;
                py?: any;
                mx?: any;
                my?: any;
                containerWidth?: any,
                backgroundImageUrl?: any,
                backgroundVideoUrl?: any,
                component?: any,
                enableSectionSpacing?: any,
                enableTitle?: any,
                backgroundImagePosition?: any,
                backgroundImageFit?:any,
                enableBackgroundImage?: any,
                showAdvancedSettings?: any,
                enableBackgroundMask?:any,
                enableContainer?: any,
                enableSectionSmooth?: any,
                data?: any,
                mobileOrder?: any,
                providerChanel? : any
    }) {
        if(section?.title){
            this.title = section.title;
        }
        if(section?.enableSectionSpacing !== undefined){
            this.enableSectionSpacing = section.enableSectionSpacing;
        }
        if(section?.enableSectionSmooth !== undefined){
            this.enableSectionSmooth = section.enableSectionSmooth;
        }
        if(section?.enableBackgroundMask !== undefined){
            this.enableBackgroundMask = section.enableBackgroundMask;
        }
        if(section?.backgroundImageFit){
            this.backgroundImageFit = section.backgroundImageFit;
        }

        if(section?.backgroundImagePosition){
            this.backgroundImagePosition = section.backgroundImagePosition;
        }
        if(section?.showAdvancedSettings){
            this.showAdvancedSettings = section.showAdvancedSettings;
        }
        if(section?.enableBackgroundImage !== undefined){
            this.enableBackgroundImage = section.enableBackgroundImage;
        }
        if(section?.enableTitle !== undefined){
            this.enableTitle = section.enableTitle;
        }
        if(section?.type){
            this.type = section.type;
        }
        if(section?.backgroundColor){
            this.backgroundColor = section.backgroundColor;
        }
        if(section?.backgroundImageUrl){
            this.backgroundImageUrl = section.backgroundImageUrl;
        }
        if(section?.backgroundVideoUrl){
            this.backgroundVideoUrl = section.backgroundVideoUrl;
        }
        if(section?.enableContainer !== undefined){
            this.enableContainer = section?.enableContainer;
        }
        if(section?.subtitle){
            this.subtitle = section.subtitle;
        }
        if(section?.sortOrder){
            this.sortOrder = section.sortOrder;
        }
        if(section?.component){
            this.component = section.component;
        }
        if(section?.mx){
            this.mx = section.mx;
        }
        if(section?.my){
            this.my = section.my;
        }
        if(section?.px){
            this.px = section.px;
        }
        if(section?.py){
            this.py = section.py;
        }
        if(section?.data){
            this.data = section.data;
        }
        if(section?.mobileOrder){
            this.mobileOrder = section.mobileOrder;
        }
        if(section?.providerChanel){
            this.providerChanel = section.providerChanel
        }
    }
}
